import { FC } from 'react';
import type { MaquinasPayload, VisaoGeralMes } from '@/types/dashboards';
import { fmtData, fmtDataHora, fmtDiaMes } from '@/utils/painelFormat';
import Aviso from '../Aviso';
import { STATUS } from '../chartTheme';

const DIA_MS = 86_400_000;

/** Primeiro dia ainda aberto: `corte − (dias_para_fechar − 1)`. */
function primeiroDiaAberto(corte: string, diasParaFechar: number): string {
  const t = Date.parse(`${corte}T00:00:00Z`) - (diasParaFechar - 1) * DIA_MS;
  return new Date(t).toISOString().slice(0, 10);
}

/** O que muda a leitura do MFR: réplica parada e os dias cujas OPs ainda estão sendo reportadas. */
const AvisosMaquinas: FC<{ payload: MaquinasPayload; mes: VisaoGeralMes }> = ({ payload, mes }) => {
  const { frescor, corte, dias_para_fechar: dias } = payload;
  return (
    <>
      {frescor.replica_atrasada && (
        <Aviso testId="maq-aviso-replica" icone="cloud_off" cor={STATUS.critico} titulo="Réplica do Datasul parada">
          A última carga foi em {fmtDataHora(frescor.ultima_carga_replica)}
          {frescor.dias_sem_carga !== null && <> ({frescor.dias_sem_carga} dias)</>}. A produção vai só até{' '}
          {fmtData(frescor.producao_ate)}.
        </Aviso>
      )}
      {mes.em_andamento && (
        <Aviso testId="maq-aviso-aberto" icone="hourglass_top" cor={STATUS.atencao} titulo={`${mes.label} ainda está aberto`}>
          A OP é reportada de uma vez no fim do processo, e as de {fmtDiaMes(primeiroDiaAberto(corte, dias))} a{' '}
          {fmtDiaMes(corte)} ainda estão chegando: aparecem na matriz (em itálico), mas só entram na semana e no mês quando o
          dia fecha. Dias depois de {fmtDiaMes(corte)} mostram só o programado. O produzido do mês cresce até as OPs fecharem.
        </Aviso>
      )}
    </>
  );
};

export default AvisosMaquinas;
